import { cloneDeep } from 'lodash-es'
import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import { StorePerformance } from '@/models'
import { DisplayPerformance, DisplayShow } from '@/modules/guestUi/interfaces/shows'
import { useSettingStore } from '@/stores/setting'
import { sortBy } from '@/utils/utils'

import type { PerformanceId } from '@generated/types'

export interface UseDisplayShowsOptions {
  filter?: (p: StorePerformance) => boolean
  idsToForcePurchase?: MaybeRefOrGetter<PerformanceId[]>
}

export function useDisplayShows(
  performances: MaybeRefOrGetter<StorePerformance[]>,
  options: UseDisplayShowsOptions = {},
) {
  const settingStore = useSettingStore()

  return computed<DisplayShow[]>(() => {
    const list = toValue(performances)
    const idsToForcePurchase = toValue(options.idsToForcePurchase) ?? []
    const filter = options.filter ?? (() => true)

    const shows: DisplayShow[] = []

    for (const performance of list) {
      if (!filter(performance)) continue

      const existing = shows.find(s => s.date === performance.date && s.id === performance.show_id)
      const displayPerformance = cloneDeep(performance) as DisplayPerformance
      displayPerformance.forcePurchase = idsToForcePurchase.includes(performance.id)

      if (existing) {
        existing.performances.push(displayPerformance)
        sortBy(existing.performances, 'datetime')
      } else {
        shows.push({
          ...displayPerformance.show,
          id: displayPerformance.show_id,
          date: displayPerformance.date,
          datetime: displayPerformance.datetime,
          dateStr: settingStore.mediumDate(displayPerformance.datetime),
          description: displayPerformance.show?.description ?? '',
          position: displayPerformance.show?.position ?? [],
          performances: [displayPerformance],
        })
      }
    }

    return sortBy(shows, 'datetime')
  })
}
